import React, { createContext, useContext, useMemo, useState } from 'react';

type ListHoverContextValue = {
  someRowIsHovered: boolean;
  setSomeRowIsHovered: (isHovered: boolean) => void;
};

const DEFAULT_CONTEXT_VALUE: ListHoverContextValue = {
  someRowIsHovered: false,
  setSomeRowIsHovered: () => undefined,
};

const ListHoverContext = createContext<ListHoverContextValue>(
  DEFAULT_CONTEXT_VALUE,
);

export const ListHoverProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [someRowIsHovered, setSomeRowIsHovered] = useState(false);

  const value = useMemo(
    () => ({ someRowIsHovered, setSomeRowIsHovered }),
    [someRowIsHovered],
  );

  return (
    <ListHoverContext.Provider value={value}>
      {children}
    </ListHoverContext.Provider>
  );
};

export const useListHover = (): ListHoverContextValue =>
  useContext(ListHoverContext);
